// Use /api prefix to route through proxy server (avoids CORS)
// proxy server will forward requests to http://slt_api.devtester.xyz
export const HOST = '/api';
export const WEB_CLIENT = 'internal-api/v1/client-web';
export const USER_CLIENT_OPEN = 'internal-api/v1/user-web-open';

export const FETCH_ENTITY_LIST = `${HOST}/${WEB_CLIENT}/entity-panel/config/list`;
export const FETCH_ENTITY_BRANCH_LIST = `${HOST}/${WEB_CLIENT}/entity-panel/entity-branch/config/list`;
export const FETCH_ENTITY_REGISTRATION_META = `${HOST}/${WEB_CLIENT}/entity-panel/registration/meta`;
export const NEW_ENTITY_REGISTRATION = `${HOST}/${WEB_CLIENT}/entity-panel/registration/new-entity`;
export const FETCH_DESTINATION_LIST = `${HOST}/${WEB_CLIENT}/destination-panel/config/list`;
export const FETCH_DESTINATION_REGISTRATION_META = `${HOST}/${WEB_CLIENT}/destination-panel/registration/meta`;
export const NEW_DESTINATION_REGISTRATION = `${HOST}/${WEB_CLIENT}/destination-panel/registration/new-destination`;
export const FETCH_DESTINATION_TICKET_REGISTRATION_META = `${HOST}/${WEB_CLIENT}/destination-panel/ticket/meta`;
export const FETCH_REGISTRATION_META = `${HOST}/${WEB_CLIENT}/destination-panel/registration/meta`;
